<!-- START: Navbar -->
<div class="yt-navbar d-flex flex-row align-items-center gap-3">
  <i class="bi bi-list"></i>
  <div class="yt-brand d-flex flex-row align-items-center">
    <svg class="yt-logo" viewBox="0 0 24 17" aria-hidden="true" focusable="false">
      <rect width="24" height="17" rx="5" ry="5" fill="#ff0000" />
      <polygon points="9.6,4.4 17,8.5 9.6,12.6" fill="#fff" />
    </svg>
    <span class="yt-wordmark">YouTube</span>
  </div>

  <input class="yt-search placeholder" type="search" name="" id="" disabled/>
</div>
<!-- End: Navbar -->